import React from "react";
import DeviceList from "./DeviceList.js";

export default props => <DeviceList {...props} />;
